import { gridSizeMdLg12, gridSizeMdLg4, gridSizeMdLg6, gridSizeMdLg8, napsSchema, ROUTER_PATHS } from "@/shared";
import { yupResolver } from "@hookform/resolvers/yup";
import { 
  useEffect, 
  useMemo, 
  useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";

import {
  getCajaPrimarias,
  useCreateNaps,
  useFetchOperadoras,
  // useFetchCajasPrimarias,
  // useFetchCitiesEnabled,
  // useFetchNodos,
  // useFetchOLTs,
  // useFetchSectors,
  useUpdateNaps,
} from "@/shared/actions/erp";
import {
  CustomAutocomplete,
  CustomAutocompleteArrString,
  CustomNumberTextField,
  CustomTextArea,
  CustomTextAreaNoForm,
  // CustomAutocomplete,
  // CustomNumberTextField,
  CustomTextField,
  CustomTextFieldNoForm,
  SampleDatePicker,
  SingleFormBoxScene,
  SwitchComponenteForm,
} from "@/shared/components/ui";
import PortsSelect from "@/shared/components/ui/PuertosSelect";
import { CajaPrimaria, EstadoIpv4, Naps, PuertoNap } from "@/shared/interfaces";
import { useUiStore } from "@/store/ui";
import { Grid } from "@mui/material";
import CustomCoordendasForm from "@/erp/venta-corporativa/preventa_corporativo/shared/form_coordenadas/CustomCoordendasForm";
import CustomAutocompleteFetchForm from "@/shared/components/ui/CustomAutocompleteFetchForm";
import useAutocompleteFetch from "@/shared/hooks/useAutocompleteFetch";
import { Operadora } from "@/shared/interfaces/erp/configuracion-red/operadora/operadora.interface";
import dayjs from "dayjs";
import { ContarPuertosNap } from "../SemaforoPuertos";
const returnUrlCajaSecundaria = ROUTER_PATHS.configuracionRED.napsNav;

const ARRAY_TECNICOS_PROYECTOS = [
  "Edgar Leonardo Mariscal Cachumba",
  "Juan Fernando Ordóñez Ordóñez",
  "Ángel Ruben Altamirano Guzman",
  "Franklin Javier Folleco Espinoza",
  "Kevin Wladimir Piedra Hernández",
  "Jonathan Miguel Paez Pillajo",
  "Eddy Alexander Caiza Lema",
  "Michael Raúl Iza Peñafiel",
  "Paolo René Narvaez Antamba",
  "Luis Alfredo Chavez Silva",
  "Mario Efrain Salinas Lucero",
  "Darwin Ariel García Macias",
  "Juan Carlos Amagua Salinas",
  "Juan Carlos Obando Zambrano",
  "Edwin Fernando Silva Villavicencio",
  "Jonathan Guillermo Requelme Chuquisan",
  "Stalyn David Cofre Guzman",
  "Alexis Sebastian Chicaiza Tenesaca",
  "Anthony Vicente Mendoza Sabando",
  "Mario Armando Cocha Umatambo",
  "Richard Paul Rosado Mendoza",
  "Wilson Israel Tenesaca Criollo",
  "Marco Fabian Chiquito Chacho",
  "Juan Carlos Macias Contreras"
]
export interface SaveNapsProps {
  titlePage: string;
  editNaps?: Naps;
}
type SaveFormData = {
  nombre: string;
  coordenadas: string;
  latitud?:string;
  longitud?:string;
  caja_primaria?: string;
  nombre_caja_primaria ?: string;
  operadora?: string;
  fecha_instalacion?: string;
  user_instalacion?: string;
  nombre_tecnico_instalacion?: string;
  observaciones?: any;
  observacion_nap?: string
  es_soterrado?: boolean
  // sector?: string;
  // tipo_caja: string
  
  codigo?: string;
  estado_fisico_nap?: string;
  estado?: boolean;
  puertos?: PuertoNap[];

  potencia?: number;

  puertos_disponibles?: number;
  puertos_ocupados?: number;
  naps_desfogue?: any;
  nombre_operadora?: string;
};
const SaveNaps: React.FC<SaveNapsProps> = ({titlePage, editNaps }) => {
  const navigate = useNavigate();

  //*local state
  // const [shrink, setShrink] = useState(false);
  const [portCount, setPortCount] = useState(
    editNaps?.puertos?.length.toString() ?? "16"
  ); // Inicializa el estado con el valor por defecto

  // ...resto del código

  ///* global state
  const setAlert = useUiStore((s) => s.setAlert);

  ///* fetch data
  // const { data: SectorsPaging, isLoading: isLoadingSectors } = useFetchSectors({
  //   page_size: 600,
  // });
  // const { data: CitiesPaging, isLoading: isLoadingCities } =
  //   useFetchCitiesEnabled({
  //     params: {
  //       page_size: 600,
  //     },
  //     enabled: true,
  //   });
  // const { data: OLTPaging, isLoading: isLoadingOLT } = useFetchOLTs({
  //   params: {
  //     page_size: 600,
  //   },
  // });
  // const { data: NodoPaging, isLoading: isLoadingNodo } = useFetchNodos({
  //   page_size: 600,
  // });
  ///* form
  useEffect(() => {
    const newPorts: any[] = [];
    for (let i = 0; i < Number(portCount); i++) {
      newPorts.push({ estado: EstadoIpv4.DISPONIBLE, puerto: `${i + 1}`, id_cliente_contrato:null });
    }
    form.reset({
      ...form.getValues(),
      puertos:newPorts,
      puertos_disponibles:parseInt(portCount||"16"),
      puertos_ocupados:0,
    })
  }, [portCount]);
  const form = useForm<SaveFormData>({
    resolver: yupResolver(napsSchema),
  });
  const {
    handleSubmit,
    reset,
    setError,
    formState: { errors, isValid },
  } = form;
  ///* mutations
  const createNaps = useCreateNaps({ navigate, returnUrl: returnUrlCajaSecundaria });
  const updateNaps = useUpdateNaps({ navigate, returnUrl: returnUrlCajaSecundaria });
  const {
    data: operadorasPagingRes,
    isLoading: isLoadingOperadoras,
  } = useFetchOperadoras({})
  const {
    fetchAutocompleteCajaTroncal,
    // fetchAutocompleteFlota
  } = useAutocompleteFetch();

  const cajaPrimaria = form.watch()?.caja_primaria
  const operadora = form.watch()?.operadora
  const cajaPrimariaParams = useMemo(() => ({
    caja_primaria: cajaPrimaria
  }), [cajaPrimaria, operadora])

  // const {
  //     data: CajasPrimariasData,
  //     isLoading: isLoadingCajasPrimarias,
  //     isRefetching: isRefetchingCajasPrimarias,
  // } = useFetchCajasPrimarias({
  //   enabled: true, ///* zona
  //   params: {
  //     page_size: 1000,
  //     estado: true,
  //     codigo: form.getValues()?.caja_primaria || undefined
  //   },
  // });
  ///* handlers
  const onSave = () => {
    console.log({errors, isValid})
    console.log(form.getValues())

    if (!isValid) return;
    if(!form.getValues()?.caja_primaria && form.getValues()?.estado){
      setAlert(true, "No puede crear una NAP con estado activo sin seleccionar una caja primaria", "error");
      return 
    }

    const latLongCoordenadas =  form.getValues()?.coordenadas?.split(",")
    const lat = latLongCoordenadas?.[0]?.split(".")
    const long = latLongCoordenadas?.[1]?.split(".")
    reset({
      ...form.getValues(),
      fecha_instalacion: form.getValues()?.fecha_instalacion ? dayjs(form.getValues()?.fecha_instalacion as any).format('YYYY-MM-DD') : undefined,
      latitud: lat?.[0]+"."+lat?.[1]?.substring(0,14),
      longitud: long?.[0]+"."+long?.[1]?.substring(0,14),
      observaciones:{
        observacion_nap: form.getValues()?.observacion_nap || "",
      }
    })

    if (editNaps?.id_nap) {
      return updateNaps.mutate({
        id: editNaps.id_nap,
        data: form.getValues() as any,
      },{
        onError: (error) => {
          const errors = (error as any)?.response?.data?.data?.errors;
          for(const field in errors){
            setError(field as any, {
              type: "manual",
              message: errors[field],
            });
          }
        }
      });
    }
    ///* create
    return createNaps.mutate(form.getValues() as any, {
      onError: (error) => {
        const errors = (error as any)?.response?.data?.data?.errors;
        for(const field in errors){
          setError(field as any, {
            type: "manual",
            message: errors[field],
          });
        }
      }
    });
  };
  ///*fetch
  // const onChangeCities = (value: string) => {
  //   form.setValue("ciudad", value);
  // };
  // const onChangeSectors = (value: string) => {
  //   form.setValue("sector", value);
  // };

  useEffect(() => {
    if (editNaps) {
      const { OCUPADO, DISPONIBLE } = ContarPuertosNap(editNaps?.puertos || []);
      console.log({OCUPADO, DISPONIBLE})
      // setShrink(true);
      reset({
        ...editNaps,
        fecha_instalacion: editNaps?.fecha_instalacion ? dayjs(editNaps?.fecha_instalacion as any)?.format('YYYY-MM-DD') : undefined,
        // estado: false,
        observacion_nap: editNaps?.observaciones?.observacion_nap || "",
        puertos_ocupados: OCUPADO,
        puertos_disponibles: DISPONIBLE,
      });
    }else{
      reset({
        ...form.getValues(),
        // estado: false,
        observacion_nap: "",
      });
    }
  }, [editNaps]);

  return (
    <SingleFormBoxScene
      titlePage={titlePage||"Naps"}
      // enableBackBtn={true}
      // backPageUrl="/configuracion-red/naps"
      // visibleReport={false}
      // enableCreateOrEditBtn={true}
      // textCreateOrEditBtn="Guardar"
      // fnCreateOrEdit={handleSubmit(onSave, () => {
      //   setAlert(true, "Faltan campos por llenar", "error");
      // })}

      onCancel={() => {
        navigate(returnUrlCajaSecundaria);
      }}
      onSave={handleSubmit(onSave, (_err) => {
        // console.log(err)
        setAlert(true, "Faltan campos por llenar", "error");
      })}


    >
      <Grid item container spacing={3}>

        <CustomAutocomplete<Operadora>
          label="Seleccione la Operadora"
          name="operadora"
          options={operadorasPagingRes?.data?.data || []}
          valueKey="nombre"
          actualValueKey="codigo"
          defaultValue={form.getValues().operadora}
          optionLabelForEdit={form.getValues().operadora}
          isLoadingData={isLoadingOperadoras}
          control={form.control}
          error={errors.operadora}
          helperText={
            errors.operadora?.message
          }
          onChangeRawValue={(value)=>form.setValue("nombre_operadora", value?.nombre || "")}
          size={gridSizeMdLg6}
          required={false}
        />

        <CustomAutocompleteFetchForm<CajaPrimaria>
          // disabled={!bodega_destino}
          size={gridSizeMdLg6}
          control={form.control}
          name="caja_primaria"
          label="Manga"
          ///* fetch
          fetchParams={cajaPrimariaParams}
          fetchData={fetchAutocompleteCajaTroncal}
  
          getOptionLabel={(opt) => `${opt.nombre}` || ''}
          key={'autocomplete-caja-primaria'}
          getOptionKey={(opt) => opt.codigo}
          initialInputValue={form.getValues().caja_primaria ?? ''}
          loadOptionByValue={async (codigo) => {
            console.log('codigo', codigo);
            const res = await getCajaPrimarias({
              codigo: codigo as string
            });
            return res.data.data[0] ?? null
  
          }}
          onChangeValue={(e) => {
            reset({
              ...form.getValues(),
              caja_primaria: e as string
            })
            if(form.getValues()?.caja_primaria != editNaps?.caja_primaria){
              form.setValue("nombre", "");
            }
          }}
          required={false}
          onChangeRawValue={(val)=>{
            form.setValue("nombre_caja_primaria", val?.nombre)
          }}
          disabled={!!operadora? false:true}
  
        />
        <CustomTextField
          name="nombre"
          label="Nombre"
          control={form.control}
          defaultValue={form.getValues().nombre}
          error={errors.nombre}
          helperText={errors.nombre?.message}
          size={gridSizeMdLg12}
          disabled={editNaps? false : !form.getValues()?.caja_primaria}
        />
        {/* <CustomTextField
          name="tipo_caja"
          label="Tipo Caja"
          control={form.control}
          defaultValue={form.getValues().tipo_caja || ""}
          error={errors.tipo_caja}
          helperText={errors.tipo_caja?.message}
          shrink={shrink}
          size={gridSizeMdLg6}
        /> */}
        {/* {
          isLoadingCajasPrimarias?
          <Grid {...gridSizeMdLg12} item container spacing={3} justifyContent="center" display={"flex"}>
            <CircularProgress size={30}/>
          </Grid>
          :
          <CustomAutocomplete<CajaPrimaria>
            label="Manga"
            name="caja_primaria"
            //// options
            options={CajasPrimariasData?.data?.data || []}
            // label & id as fk
            valueKey="nombre"
            actualValueKey="codigo"
            defaultValue={form.getValues().caja_primaria || ''}
            isLoadingData={isLoadingCajasPrimarias || isRefetchingCajasPrimarias}
            //// validation
            control={form.control}
            error={errors.caja_primaria}
            helperText={errors.caja_primaria?.message}
            size={gridSizeMdLg12}
          />
        } */}
        
        
        {/* <CustomAutocomplete<OLT>
          label="OLT"
          name="olt"
          actualValueKey="codigo"
          //// options
          options={OLTPaging?.data.data || []}
          // label & search by name
          valueKey="nombre"
          //
          defaultValue={form.getValues().olt || ""}
          optionLabelForEdit={form.getValues().olt || ""}
          isLoadingData={isLoadingOLT}
          //// validation
          control={control}
          error={errors.olt}
          helperText={errors.olt?.message}
          onChangeValue={(e) => form.setValue("olt", e)}
          size={gridSizeMdLg6}
        /> */}
        {/* <CustomAutocomplete<Nodo>
          label="Nodo"
          name="nodo"
          actualValueKey="codigo"
          //// options
          options={NodoPaging?.data.data || []}
          // label & search by name
          valueKey="nombre"
          //
          defaultValue={form.getValues().nodo || ""}
          optionLabelForEdit={form.getValues().nodo || ""}
          isLoadingData={isLoadingNodo}
          //// validation
          control={control}
          error={errors.nodo}
          helperText={errors.nodo?.message}
          onChangeValue={(e) => form.setValue("nodo", e)}
          size={gridSizeMdLg6}
        /> */}

        <CustomCoordendasForm
          form={form}
          label="Coordendas"
          name="coordenadas"
          defaultValue={form.watch().coordenadas}
          key={'key_nodo_coordenadas'}
          size={gridSizeMdLg12}
          onlyValueLocation={true}
          enableLocationOnChange={false}
        />
        
        {/* <CustomTextField
          name="coordenadas"
          label="Coordenadas"
          type="coordenadas"
          control={form.control}
          defaultValue={form.getValues().coordenadas || ""}
          error={errors.coordenadas}
          helperText={errors.coordenadas?.message}
          shrink={shrink}
          size={gridSizeMdLg6}
          disabled
        /> */}
        {/* <CustomTextField
          name="direccion"
          label="Direccion"
          control={form.control}
          defaultValue={form.getValues().direccion || ""}
          error={errors.direccion}
          helperText={errors.direccion?.message}
          shrink={shrink}
          size={gridSizeMdLg6}
        /> */}

        {/* <CustomTextField
          name="latitud"
          type="latitud"
          label="Latitud"
          control={form.control}
          defaultValue={form.getValues().latitud || ""}
          error={errors.latitud}
          helperText={errors.latitud?.message}
          shrink={shrink}
          size={gridSizeMdLg6}
          onChangeValue={(value, valid) => {
            if (valid) {
              form.setValue(
                "coordenadas",
                `${value},${form.getValues().longitud}`
              );
            }
          }}
        />

        <CustomTextField
          name="longitud"
          type="longitud"
          label="Longitud"
          control={form.control}
          defaultValue={form.getValues().longitud || ""}
          error={errors.longitud}
          helperText={errors.longitud?.message}
          shrink={shrink}
          size={gridSizeMdLg6}
          onChangeValue={(value, valid) => {
            if (valid) {
              form.setValue(
                "coordenadas",
                `${+form.getValues().latitud},${value} `
              );
            }
          }}
        /> */}

        {/* <CustomTextField
          name="proyecto_cod"
          label="Código de Proyecto"
          control={form.control}
          defaultValue={form.getValues().proyecto_cod || ""}
          error={errors.proyecto_cod}
          helperText={errors.proyecto_cod?.message}
          shrink={shrink}
          size={gridSizeMdLg6}
        /> */}

        
        
        {/* <CustomAutocomplete<City>
          label="Ciudad"
          name="ciudad"
          //// options
          options={CitiesPaging?.data.data || []}
          // label & search by name
          valueKey="nombre"
          actualValueKey="codigo"
          //
          defaultValue={form.getValues().ciudad || ""}
          isLoadingData={isLoadingCities}
          //// validation
          control={control}
          error={errors.ciudad}
          helperText={errors.ciudad?.message}
          onChangeValue={onChangeCities}
          size={gridSizeMdLg6}
          optionLabelForEdit={
            CitiesPaging?.data.data.find(
              (z: any) => z.codigo === form.getValues().ciudad
            )?.nombre ?? ""
          }
        />
        <CustomAutocomplete<Sector>
          label="Sector"
          name="sector"
          //// options
          options={SectorsPaging?.data.data || []}
          // label & search by name
          valueKey="nombre"
          actualValueKey="codigo"
          //
          defaultValue={form.getValues().sector || ""}
          optionLabelForEdit={
            SectorsPaging?.data.data.find(
              (z: any) => z.codigo === form.getValues().sector
            )?.nombre ?? ""
          }
          isLoadingData={isLoadingSectors}
          //// validation
          control={control}
          error={errors.sector}
          helperText={errors.sector?.message}
          onChangeValue={onChangeSectors}
          size={gridSizeMdLg6}
        /> */}

        <PortsSelect
          label="Puertos"
          register={{ onChange: (event) => setPortCount(event.target.value) }}
          defaultValue={portCount}
          size={gridSizeMdLg4}
        />

        <CustomTextFieldNoForm
          // name="puertos_disponibles"
          label="Puertos Disponibles"
          value={form.getValues()?.puertos_disponibles 
            // || form.getValues()?.puertos?.map(x=>x.estado==EstadoPuertoNap.DISPONIBLE)?.length 
            // || form.watch()?.puertos?.length
            || 0}
          shrink={true}
          size={gridSizeMdLg4}
          disabled
        />
        <CustomTextFieldNoForm
          // name="puertos_disponibles"
          label="Puertos Ocupados"
          value={form.getValues()?.puertos_ocupados || 0}
          shrink={true}
          size={gridSizeMdLg4}
          disabled
        />
        {/* <CustomNumberTextField
          name="puertos_ocupados"
          label="Puertos Ocupados"
          control={form.control}
          defaultValue={form.getValues().puertos_ocupados || ""}
          error={errors.puertos_ocupados}
          helperText={errors.puertos_ocupados?.message}
          shrink={shrink}
          size={gridSizeMdLg6}
          disabled
        /> */}

        {/* <SampleCheckbox
          label="Soterrado"
          name="es_soterrado"
          control={form.control}
          defaultValue={!!form.getValues().es_soterrado}
          size={gridSizeMdLg6}
        /> */}

        {/* <SampleCheckbox
          label="Estado NAP"
          name="estado_fisico_nap"
          control={form.control}
          defaultValue={!!form.getValues().estado_fisico_nap||true}
          size={gridSizeMdLg6}
        /> */}
        <CustomAutocompleteArrString
          label="Estado Físico de NAP"
          name="estado_fisico_nap"
          control={form.control}
          defaultValue={"PENDIENTE"}
          options={["HABILITADA","NO HABILITADA","PENDIENTE","SIN POTENCIAS"]}
          isLoadingData={false}
          error={errors.estado_fisico_nap}
          helperText={errors.estado_fisico_nap?.message}
          size={gridSizeMdLg8}
          disableClearable
        />
        <SwitchComponenteForm
          label={form.watch()?.estado ? 'Activo' : 'Inactivo'}
          size={gridSizeMdLg4}
          control={form.control}
          defaultValue={!!form.getValues()?.estado}
          name="estado"
        />
        <CustomNumberTextField
          label="Potencia (dBm)"
          name="potencia"
          control={form.control}
          defaultValue={form.getValues().potencia || 0}
          error={errors.potencia}
          helperText={errors.potencia?.message}
          shrink={true}
          size={gridSizeMdLg8}
          startAdornment="-"
        />
        <SwitchComponenteForm
          label={`Soterrado: ${form.getValues()?.es_soterrado ? 'Sí' : 'No'}`}
          size={gridSizeMdLg4}
          control={form.control}
          defaultValue={!!form.getValues()?.es_soterrado}
          name="es_soterrado"
        />

        <SampleDatePicker
          label="Fecha de Instalación"
          name="fecha_instalacion"
          control={form.control}
          onChangeValue={(value) => {
            form.setValue('fecha_instalacion', value);
          }}
          // type="date"
          defaultValue={form.getValues()?.fecha_instalacion ? dayjs(form.getValues()?.fecha_instalacion).format('YYYY-MM-DD') : null}
          error={errors.fecha_instalacion}
          helperText={errors.fecha_instalacion?.message}
          size={gridSizeMdLg6}
          required={false}
        />

        <CustomTextField
          label="Usuario que registra"
          name="user_instalacion"
          control={form.control}
          defaultValue={form.getValues().user_instalacion || ""}
          error={errors.user_instalacion}
          helperText={errors.user_instalacion?.message}
          size={gridSizeMdLg12}
          shrink={true}
          required={false}
          disabled
        />
        
        {/* <CustomAutocompleteFetchForm<Flota>
          control={form.control}
          required={false}
          size={gridSizeMdLg12}
          name="nombre_tecnico_instalacion"
          label="Nombre Técnico Instalación"
          fetchData={fetchAutocompleteFlota} ///* TODO: Pendiente revisar
          getOptionLabel={(opt) => `${opt.nombre}` || ''}
          initialInputValue={form.getValues()?.nombre_tecnico_instalacion ?? ''}
          fetchParams={{
            disable_all_option: true
          }}
          key={'autocomplete-nombre_tecnico_instalacion'}
          getOptionKey={(opt) => opt.nombre}
          isAll={false}
          loadOptionByValue={async (nombre) => {
            console.log('nombre', nombre);
            const res = await getFlotaAll({
              nombre: nombre as string
            });
            return res.data.data[0] ?? null
  
          }}
          //getValue={(opt) => opt.codigo}
          //valueKey="codigo"
          onChangeValue={(e) => {
            form.setValue('nombre_tecnico_instalacion', e as string)

          }}
        /> */}
        <CustomAutocompleteArrString
          label="Nombre Técnico Instalación"
          name="nombre_tecnico_instalacion"
          control={form.control}
          defaultValue={form.getValues("nombre_tecnico_instalacion")}
          options={ARRAY_TECNICOS_PROYECTOS}
          isLoadingData={false}
          error={errors.nombre_tecnico_instalacion}
          helperText={errors.nombre_tecnico_instalacion?.message}
          size={gridSizeMdLg12}
        />
        
        {/* // <CustomTextField
        //   label="Nombre Técnico Instalación"
        //   name="nombre_tecnico_instalacion"
        //   control={form.control}
        //   defaultValue={form.getValues().nombre_tecnico_instalacion || "N/D"}
        //   error={errors.nombre_tecnico_instalacion}
        //   helperText={errors.nombre_tecnico_instalacion?.message}
        //   size={gridSizeMdLg12}
        //   shrink={true}
        //   required={false}
        // /> */}

        <CustomTextArea
          label="Observación NAP"
          name="observacion_nap"
          required={false}
          control={form.control}
          defaultValue={form.getValues().observacion_nap || ""}
          error={errors.observacion_nap}
          helperText={errors.observacion_nap?.message}
          size={gridSizeMdLg12}
        />


        <CustomTextAreaNoForm
          label="Naps de Desfogue"
          value={form.getValues()?.naps_desfogue|| ""}
          size={gridSizeMdLg12}
          shrink={true}
          required={false}
          disabled
        />
      </Grid>
    </SingleFormBoxScene>
  );
};

export default SaveNaps;
